import React from 'react';

const Logo = () => {
    return (
        <div className="logo">
         <img src="./assets/logo192.png" alt="logo"/>
           <h3>React World</h3> 
        </div>
    );
};

export default Logo;